import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import { clearTencentConnectionDialog, selectTencentConnectionDialog } from '../../reducers/uiSlice'

/**
 * No usa `CustomDialog` a propósito: producto definió para este cartel un ícono de advertencia y
 * una X, y ese componente es compartido con los diálogos de navegador no soportado, permisos y
 * varios más. Darle esta cara allá les cambiaría la cara a todos.
 */
const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(2),
    maxWidth: 420,
    position: 'relative',
  },
  close: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(4),
  },
  icon: {
    fontSize: 56,
  },
}))

export const TencentConnectionDialog = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const classes = useStyles()
  const { open } = useSelector(selectTencentConnectionDialog)

  const handleClose = () => {
    dispatch(clearTencentConnectionDialog())
  }

  return (
    <Dialog
      aria-labelledby="tencent-connection-title"
      aria-describedby="tencent-connection-description"
      open={open}
      // Se puede cerrar por Escape y por el fondo, no sólo por la X: este cartel se superpone al
      // video, al chat y al carrito, y quedar encerrado detrás de él ya fue un defecto reportado.
      onClose={handleClose}
      classes={{ paper: classes.paper }}
    >
      <IconButton
        className={classes.close}
        onClick={handleClose}
        size="small"
        aria-label={t('dialogs.closeButton')}
        data-test="tencent-connection-close"
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className={classes.content}>
        <ReportProblemOutlinedIcon
          className={classes.icon}
          color="primary"
          aria-hidden="true"
          data-test="tencent-connection-icon"
        />
        <Typography id="tencent-connection-title" component="h2" variant="h5" color="primary">
          {t('dialogs.tencentConnection.title')}
        </Typography>
        <Typography
          id="tencent-connection-description"
          component="p"
          variant="subtitle2"
          color="primary"
        >
          {t('dialogs.tencentConnection.description')}
        </Typography>
      </DialogContent>
    </Dialog>
  )
}
